import React, { Component } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import clsx from "clsx";
import ImageView, { ImageProps } from "./ImageView";
import MediaOverlayService from "./AppMediaOverlay";
import { getViewImage, getViewImageLink } from "../../../utils";
import { IImage } from "../../../models/Image";
import { GalleryProps } from "./MediaOverlay";
import { FileType } from "../../../laco-common/base/models/IFile";

export type ImageEnlargeProps = {
	image: IImage;
	width?: number;
	height?: number;
	displayShare?: boolean;
	displayThumb?: boolean;
	hideHover?: boolean;
	className?: string;
	renderSimple?: boolean;
} & Pick<ImageProps, "isPercentage" | "imageWidth100Pct" | "scaleInEffect" | "renderContainer"> &
	GalleryProps;

type ImageEnlargeState = {
	openMedia: boolean;
	selectedImageIndex?: number;
};

class ImageEnlarge extends Component<RouteComponentProps & ImageEnlargeProps, ImageEnlargeState> {
	private historySub: any;

	state = {
		openMedia: false,
	};

	componentDidMount() {
		this.initViewImage(this.props.location);
		this.historySub = this.props.history.listen((location, action) => {
			this.initViewImage(location);
		});
	}

	componentWillUnmount() {
		if (this.historySub) this.historySub();
	}

	// check if need to open modal - shared link
	initViewImage(location: { hash: string; search: string }) {
		const img = getViewImage(location);
		console.log("initViewImage():", location, img);
		if (img) {
			setTimeout(() => {
				if (this.props.image.filename === img) {
					this.showImage(true);
				}
			}, 700);
		}
	}

	openModal() {
		this.showImage();
		// this.props.history.replace({
		// 	pathname: this.props.location.pathname,
		// 	search: `?viewImage=${this.props.image.filename}`,
		// });
	}

	showImage(fromRoute?: boolean) {
		console.log("showImage()", this.props.image);
		if (fromRoute) {
			MediaOverlayService.show(
				this.props.image,
				this.props.displayShare || false,
				this.props.galleryImages,
				this.props.selectedMediaIndex
			);
			return;
		}
		MediaOverlayService.show(
			this.props.image,
			this.props.displayShare || false,
			this.props.galleryImages,
			this.props.selectedMediaIndex
		);
		this.props.history.replace({
			pathname: this.props.location.pathname,
			search: `?${getViewImageLink(this.props.image.filename)}`,
		});
	}

	render() {
		const { className, image, width, height, ...rest } = this.props;
		if (this.props.renderSimple && this.props.image.fileType === FileType.IMAGE) {
			const styles: any = {};
			if (width) {
				styles.width = isNaN(width) ? width : `${width}px`;
			}
			if (height) {
				styles.height = isNaN(height) ? height : `${height}px`;
			}
			return (
				<img
					src={image.url}
					className={clsx("mss-image-view", className)}
					width={width}
					style={styles}
					height={height}
				/>
			);
		}
		return (
			<React.Fragment>
				<ImageView
					{...rest}
					className={className}
					image={image}
					viewWidth={width}
					viewHeight={height}
					displayEnlargeHover={this.props.hideHover ? false : true}
					enlargeCallback={this.props.hideHover ? undefined : this.openModal.bind(this)}
					displayThumb={image && (this.props.image.fileType === FileType.VIDEO || this.props.displayThumb)}
				>
					{this.props.children}
				</ImageView>
			</React.Fragment>
		);
	}
}

export default withRouter(ImageEnlarge);
